"use client";
import { Suspense } from "react";
import { Stack, Heading, Text } from "@chakra-ui/react";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import Tabs from "@/components/tabs";
import { tablist } from "./tabList";
import { DATA_CENTER_CONSTANTS } from "./constants";

const ServiceLocations = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={6} id="dataCenters">
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} px={2}>
        {DATA_CENTER_CONSTANTS.DATA_CENTER_LOCATIONS}
      </Heading>
      <Text variant={TextVariant} textAlign={"center"} color="text.100">
        {DATA_CENTER_CONSTANTS.DATA_CENTER_DESC}
      </Text>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
    </Stack>
  );
};

export default ServiceLocations;
